import React, {useMemo} from 'react'
import moment from 'moment'
import SortableTable, {ColumnConfig} from '../SortableTable'
import Routes from '../../constants/RouteConstants'
import {withRouter} from 'react-router-dom'
import AnnouncementsConstant from './AnnouncementsConstant'

export function getAnnouncementStatus(announcement) {
  const now = moment()
  const start = moment(announcement.activeStart)
  const end = moment(announcement.activeEnd)
  const isActive = now >= start && now <= end
  return isActive ? AnnouncementsConstant.STATUS_ACTIVE : AnnouncementsConstant.STATUS_INACTIVE
}

function AnnouncementsTable(props) {
  const columns = useMemo(() => [
    new ColumnConfig({
      title: 'Title',
      render: a => a.headline,
      comparator: ColumnConfig.simpleComparatorGenerator('headline'),
    }),

    new ColumnConfig({
      title: 'Posting Date',
      render: a => moment(a.activeStart).format('l'),
      comparator: (a, b) => moment(a.activeStart) - moment(b.activeStart),
      isDefaultSort: true,
      sortingDirection: 'desc',
    }),

    new ColumnConfig({
      title: 'Expiry date',
      render: a => moment(a.activeEnd).format('l'),
      comparator: (a, b) => moment(a.activeEnd) - moment(b.activeEnd),
    }),

    new ColumnConfig({
      title: 'Read',
      render: a => `${a.readResidentIds.length} / ${a.residentIds.length}`,
      comparator: (a, b) => a.readResidentIds.length - b.readResidentIds.length,
    }),

    new ColumnConfig({
      title: 'Status',
      render: a => getAnnouncementStatus(a),
      comparator: (a, b) => getAnnouncementStatus(a).localeCompare(getAnnouncementStatus(b)),
    }),
  ], [])

  return (
    <SortableTable
      data={props.announcements}
      columns={columns}
      downloadFileName={'Announcements'}
      onClickRow={a => props.history.push(Routes.constructPath(Routes.ANNOUNCEMENTS_VIEW_SINGLE, {announcementId: a.id}))}
    />
  )
}

export default withRouter(AnnouncementsTable)
